module.exports = __webpack_public_path__ + "img/27.e651cf0a.png";